import { KlearDate } from '@klear/date'
import { Money } from '@klear/money'
import {
  PAYMENT_ACCOUNT_TYPE_EXTERNAL_FINANCIAL_ACCOUNT,
  PAYMENT_TYPE_SUPPLIER,
  PAYMENT_STATUS_DRAFT,
  type PaymentStatus
} from '@klear/payment/constants'
import type { Payable, PaymentFields } from '@klear/payable/payable'
import type { PayablePaymentInput } from '@klear/payable/payable.wire'
import { PAYMENT_NETWORK_WIRE } from '@klear/bank-account/constants'
import { DEFAULT_CURRENCY_CODE } from '@klear/constants/currency'

export const NOTIFY_SUPPLIER_BY_DEFAULT = true

export type EditablePaymentFields = Omit<
  PaymentFields,
  'sourceAccountOrganizationName' | 'destinationAccountOrganizationName'
>

export function paymentFieldsFromInput(
  data: PayablePaymentInput,
  ctx?: { paymentId?: number; status?: PaymentStatus }
): EditablePaymentFields {
  return {
    paymentId: ctx?.paymentId ?? (data.id != null && data.id > 0 ? data.id : undefined),
    status: ctx?.status ?? PAYMENT_STATUS_DRAFT,
    number: data.number,
    amount: new Money(data.amount),
    effectiveDate: KlearDate.of(data.effectiveDate),
    notes: data.notes,
    internalNotes: data.internalNotes,
    statementDescriptor: data.statementDescriptor,
    notifySupplier: data.notifySupplier,
    type: data.paymentType,
    network: data.paymentNetwork,
    sourceAccountType: data.sourceAccountType,
    sourceAccountId: data.sourceAccountId,
    sourceAccountOrganizationId: data.sourceAccountOrganizationId,
    destinationAccountType: data.destinationAccountType,
    destinationAccountId: data.destinationAccountId,
    destinationAccountOrganizationId: data.destinationAccountOrganizationId
  }
}

export function paymentInputFromPayable(payable: Payable): PayablePaymentInput {
  return {
    amount: payable.amount.toJSON(),
    effectiveDate: payable.effectiveDate.toJSON(),
    paymentType: payable.type,
    paymentNetwork: payable.network,
    sourceAccountType: payable.sourceAccountType,
    sourceAccountId: payable.sourceAccountId,
    sourceAccountOrganizationId: payable.sourceAccountOrganizationId,
    destinationAccountType: payable.destinationAccountType,
    destinationAccountId: payable.destinationAccountId,
    destinationAccountOrganizationId: payable.destinationAccountOrganizationId,
    id: payable.paymentId != null && payable.paymentId > 0 ? payable.paymentId : undefined,
    number: payable.number ?? undefined,
    notes: payable.notes ?? undefined,
    internalNotes: payable.internalNotes ?? undefined,
    statementDescriptor: payable.statementDescriptor ?? undefined,
    notifySupplier: payable.notifySupplier
  }
}

export function paymentInputForNewDraft(): PayablePaymentInput {
  return {
    amount: Money.zero(DEFAULT_CURRENCY_CODE).toJSON(),
    effectiveDate: KlearDate.today().toJSON(),
    paymentType: PAYMENT_TYPE_SUPPLIER,
    paymentNetwork: PAYMENT_NETWORK_WIRE,
    sourceAccountType: PAYMENT_ACCOUNT_TYPE_EXTERNAL_FINANCIAL_ACCOUNT,
    sourceAccountId: 0,
    sourceAccountOrganizationId: 0,
    destinationAccountType: PAYMENT_ACCOUNT_TYPE_EXTERNAL_FINANCIAL_ACCOUNT,
    destinationAccountId: 0,
    destinationAccountOrganizationId: 0,
    notifySupplier: NOTIFY_SUPPLIER_BY_DEFAULT
  }
}
